import { useEffect } from 'react';

const useLockScreenOrientation = (orientation = 'portrait') => {
  useEffect(() => {
    const lockOrientation = async () => {
      if ('orientation' in screen) {
        try {
          await screen.orientation.lock(orientation);
          console.log(`Pantalla bloqueada en orientación: ${orientation}`);
        } catch (error) {
          console.error('Error al bloquear la orientación:', error);
        }
      } else {
        console.warn('Screen Orientation API no soportada en este navegador.');
      }
    };

    // Solo aplicar si está en modo standalone (PWA)
    if (window.matchMedia('(display-mode: standalone)').matches) {
      lockOrientation();
    }
  }, [orientation]);
};

export default useLockScreenOrientation;